// extracted by mini-css-extract-plugin
module.exports = {"default":"_22Uk0Nf","targetClickable":"leqq0J- _22Uk0Nf","linkClickable":"JIgPTHZ _22Uk0Nf","profile_tab":"_3huvquB _22Uk0Nf"};